﻿window.cTelephone = function (codePays, telSms) {

    if ((typeof codePays == 'undefined' || codePays == null || codePays.length == 0) && (typeof telSms != 'undefined' && telSms != null)) {
        var indic = parametre.lstIndicatifTel.filter(function (o) { return telSms.startsWith(o.dial_code) })[0]
        if (typeof indic != 'undefined') { codePays = indic.code }
        else { codePays = "" }
    }
    this.codePays = codePays

    this.hasValue = function () {
        return (typeof telSms != 'undefined' && telSms != null && telSms.length > 0)
    }

    this.mGetValue = function () {
        return telSms
    }

    this.mGetValueMiseEnForme = function () {
        if (typeof codePays == 'undefined' || codePays == null ||
            typeof telSms == 'undefined' || telSms == null) { return "" }
        else {
            var indicTel = this.mGetIndicatif()
            var dialCode = ((typeof indicTel == 'undefined') ? "" : indicTel.dial_code)
            if (telSms.startsWith("+")) telSms = telSms.substring(1)
            var telNum = telSms.substring(dialCode.length)
            if (dialCode == "33" && !telNum.startsWith("0")) telNum = "0" + telNum
            var result = dialCode + " " + msAddCaractereTel(telNum, ".")
            return ((result.trim().length == 0) ? "" : "+" + result)
        }
    }

    this.mGetIndicatif = function () {
        return parametre.lstIndicatifTel.filter(function (o) { return o.code.toLowerCase() == codePays.toLowerCase() })[0]
    }

    this.mDecoupeIndicatifTel = function (tel) {
        tel = tel.remplacerTout(" ", "")
        tel = tel.removeLettreTelephone()
        var result = null
        if (tel.startsWith("+")) tel = tel.substring(1)

        if (tel.startsWith("0")) {
            result = { code_pays: "fr", telSms: "33" + tel.substring(1) }
        } else {
            var indicTel = null
            parametre.lstIndicatifTel.forEach(function (indic) {
                if (indic.dial_code.length > 0 && tel.startsWith(indic.dial_code)) indicTel = indic
            })
            if (indicTel == null) {
                result = { code_pays: "fr", telSms: "33" + tel }
            }
            else {
                tel = tel.substring(indicTel.code.length)
                if (tel.startsWith("0")) tel = tel.substring(1)
                result = { code_pays: indicTel.code, telSms: indicTel.dial_code + tel }
            }
        }

        return result
    }

    this.mGetTelephoneDetail = function (tel) {
        var data = {}
        var tel = msRemoveToutSaufChiffre(tel)
        var lstIndicatif = mGetLstIndicatifFromTel(tel)
        if (lstIndicatif.length > 0) {
            data.dial_code = lstIndicatif[0].dial_code
            data.tel_code_pays = lstIndicatif[0].code
            data.tel_number = tel.substring(data.dial_code.length)
            data.tel_sms = data.dial_code + ((data.tel_number.startsWith("0")) ? data.tel_number.substring(1) : data.tel_number)
        } else {
            data.dial_code = ""
            data.tel_code_pays = ""
            data.tel_number = tel
            data.tel_sms = tel
        }

        if (data.dial_code.length == 0) {
            data.dial_code = "33"
            data.tel_code_pays = "fr"
        }
        data.tel_complet = "+" + data.dial_code + data.tel_number
        data.tel_sms = data.dial_code + ((data.tel_number.startsWith("0")) ? data.tel_number.substring(1) : data.tel_number)
        return data
    }

    function mGetLstIndicatifFromTel(tel) {
        var lstIndicatif = []
        parametre.lstIndicatifTel.forEach(function (indic) {
            if (tel.startsWith(indic.dial_code)) lstIndicatif.push(indic)
        })
        return lstIndicatif
    }

    function msRemoveToutSaufChiffre(s) {
        if (s == null) return s
        var n = '';
        for (j = 0; j < s.length; j++) {
            c = s.charAt(j);
            if (c == '1' || c == '2' || c == '3' || c == '4' || c == '5' || c == '6' || c == '7' || c == '8' || c == '9' || c == '0') { n = n + c; }
        }
        return n;
    }

}